import { firstBusinessDay, lastBusinessDay, } from '../constants';
export function isFirstOrLastBusinessDayFrequency(frequency) {
    return frequency === firstBusinessDay || frequency === lastBusinessDay;
}
export default isFirstOrLastBusinessDayFrequency;
//# sourceMappingURL=isFirstOrLastBusinessDayFrequency.js.map